import React, { useEffect, useState } from "react";
import "./App.css";
import { RouterProvider } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import DialogBox from "./components/DialogBox";
import { locale } from "./utils/LocaleManager";
import { useAuthStore } from "./stores/authStore";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import axios from "axios";
import { router } from "./utils/Routes";
import { theme } from "./utils/StyleHelpers";
import RolePermissions from "./components/RolePermissions";
import TokenRefresh from "./components/TokenRefresh";
import { ToastContainer } from "react-toastify";
import { authorizeApiRequest, normalizeAxiosError } from "./utils/headers";

declare module "@mui/material/Button" {
  interface ButtonPropsColorOverrides {
    custom: true;
  }
}

const msalInstance = new PublicClientApplication({
  auth: {
    clientId: `${process.env.REACT_APP_CLIENT_ID}`,
    authority: `${process.env.REACT_APP_AUTHORITY_URL}`,
    postLogoutRedirectUri: "/",
  },
  cache: {
    cacheLocation: "localStorage",
  },
});

function App() {
  console.log(
    "STAVC APP VERSION",
    `${process.env.REACT_APP_VERSION ?? "1.0.10"}`,
  );
  const setIsShowLogoutModal = useAuthStore(
    (state: any) => state.setIsShowLogoutModal,
  );
  const isShowLogoutModal = useAuthStore(
    (state: any) => state.isShowLogoutModal,
  );
  const [isApiInterceptorReady, setIsApiInterceptorReady] = useState(false);

  useEffect(() => {
    const requestInterceptorId = axios.interceptors.request.use((config) =>
      authorizeApiRequest(config, msalInstance),
    );
    const responseInterceptorId = axios.interceptors.response.use(
      undefined,
      (error) => Promise.reject(normalizeAxiosError(error)),
    );
    setIsApiInterceptorReady(true);

    return () => {
      axios.interceptors.request.eject(requestInterceptorId);
      axios.interceptors.response.eject(responseInterceptorId);
    };
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <MsalProvider instance={msalInstance}>
        {isApiInterceptorReady && (
          <>
            <TokenRefresh></TokenRefresh>
            <RolePermissions></RolePermissions>
            <RouterProvider router={router} />
          </>
        )}
        {isShowLogoutModal && (
          <DialogBox
            header={locale.logoutHeader}
            body={locale.logoutBody}
            onCancel={() => {
              setIsShowLogoutModal(false);
            }}
            onSubmit={() => {
              msalInstance.logout();
            }}
            subBody=""
            isDelete={false}
            primaryButton={locale.yes}
            secondaryButton={locale.no}
          ></DialogBox>
        )}
      </MsalProvider>
      <ToastContainer closeButton={false} />
    </ThemeProvider>
  );
}

export default App;
